import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const AcademinProgressGrid = styled(Grid)`
  display: flex;
  padding: 0px 40px;
  justify-content: space-between;
`;
